import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TabList } from 'components';
import { useNavigate } from 'react-router-dom';

function TabContainer({ tabs = [], defaultTab = '', children = () => {} }) {
  const [activeTab, setActiveTab] = useState(defaultTab);
  useEffect(() => {
    setActiveTab(defaultTab);
  }, [defaultTab]);
  const navigate = useNavigate();
  return (
    <div>
      <TabList
        tabs={tabs}
        activeTab={activeTab}
        onTabClick={tab => {
          setActiveTab(tab.name);
          navigate(tab.slugName);
        }}
      >
        {children(activeTab, setActiveTab)}
      </TabList>
    </div>
  );
}

TabContainer.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({})),
  children: PropTypes.func,
  defaultTab: PropTypes.string,
};

export default TabContainer;
